<style scoped>
.windows-sized {
  height: 100vh;
}
</style>
<template>
  <div
    class="fade page-sidebar-fixed page-header-fixed show page-container"
    id="app"
    v-if="!pageOptions.pageEmpty"
    v-bind:class="{
      'page-sidebar-minified': pageOptions.pageSidebarMinified,
      'page-content-full-height': pageOptions.pageContentFullHeight,
      'page-without-sidebar': pageOptions.pageWithoutSidebar,
      'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
      'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
      'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
      'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
      'page-with-top-menu': pageOptions.pageWithTopMenu,
      'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
      'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
      'has-scroll': pageOptions.pageBodyScrollTop,
    }"
  >
    <Header v-if="pageOptions.pageWithHeader" />
    <TopMenu v-if="pageOptions.pageWithTopMenu" />
    <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
    <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
    <div id="content" class="content" style="height: 90vh; background-color: #f2f7f8; overflow: auto" v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }">
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <Footer />
  </div>
  <div v-else>
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import Sidebar from "@/components/sidebar/Sidebar";
import TopMenu from "@/components/top-menu/TopMenu";
import PageOptions from "@/Options/PageOptions.js";

import { tooltipJson } from "@/Options/tooltip";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Sidebar,
    TopMenu,
  },
  data() {
    return {
      pageOptions: PageOptions,
      refCount: 0,
      isLoading: false,
      logoutStatus: false,
    };
  },
  methods: {
    // setLoading(isLoading){
    // 	if (isLoading) {
    // 		this.refCount++;
    // 		this.$swal({
    // 			title: 'Loading.....'
    // 		});
    // 		this.$swal.showLoading();
    // 		this.isLoading = true;
    // 	} else if (this.refCount > 0) {
    // 		this.refCount--;
    // 		this.$swal.close();
    // 		this.isLoading = (this.refCount > 0);
    // 	}
    // },
    logout() {
      this.$store.dispatch("setUser", null);
      this.$http.defaults.headers.common["Authorization"] = "";

      this.$store.dispatch("setFilterOptions", null);
      this.$store.state.lastData = null;
      this.$store.state.modules = null;
      this.$router.push({ path: "/login" });
      //delete token
    },
  },
  created() {
    this.$store.state.tooltip = tooltipJson;

    PageOptions.pageBodyScrollTop = window.scrollY;

    window.addEventListener("scroll", this.handleScroll);

    this.$insProgress.start();

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$insProgress.finish();
    });

    var user = this.$store.state.userData.userData;

    if (user) {
      this.$http.defaults.headers.common["Authorization"] = "Bearer " + user.token;
    }

    this.$http.interceptors.request.use(
      (config) => {
        if (config.url.includes("?")) {
          let splitUrl = config.url.split("?");
          let queryUrl = splitUrl[1].split("&");

          for (var i = 0; i < queryUrl.length; i++) {
            if (queryUrl[i].includes("start=")) {
              queryUrl[i] = queryUrl[i] + " 00:00:00";
            }
            if (queryUrl[i].includes("end=")) {
              queryUrl[i] = queryUrl[i] + " 23:59:59";
            }
          }

          queryUrl = queryUrl.join("&");
          config.url = splitUrl[0] + "?" + queryUrl;
        }

        // if(!config.url.includes('/v1/masterData'))
        // 	this.setLoading(true);

        return config;
      },
      (error) => {
        // this.setLoading(false);
        console.log(error);
        return Promise.reject(error);
      }
    );

    this.$http.interceptors.response.use(
      async (response) => {
        // this.setLoading(false);
        //if response is xlsx file, continue request
        if (response.headers["content-type"] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return response;
        // console.log(response.status)
        //if response code is 200, continue request
        if (response.status == 200) {
          return response;
        } else {
          return Promise.reject(error);
        }
      },
      async (error) => {
        // this.setLoading(false);
        console.log(error.response);
        if (typeof error.response === "undefined") {
          return Promise.reject("Error");
        } else if (error.response.status == 500) {
          this.$swal.fire({
            title: "Internal Server Error!",
            text: `We appologize deeply for the interruption, we are experiencing problems. Please contact our support team immediately. Error Code: 500`,
            icon: "warning",
          });
          return Promise.reject(error);
        } else if (error.response.status == 401) {
          this.$swal.fire({
            title: "You have been logged out!",
            text: "Session logon has expired, please re-login to continue.",
            icon: "warning",
          });
          await this.logout();
          return new Promise(() => {});
        }

        return Promise.reject(error);
      }
    );
  },
};
</script>

<style>
/* MPM TRANSPORTER CUSTOM DESIGNS START */
.btn--mpm--transporter {
  background-color: #cfecf9;
  color: #343434;
  font: normal normal normal 12px/18px;
}

input[readonly].mpm--transporter--flatpickr {
  background-color: #cfecf9 !important;
  height: 43px;
}

input[readonly].mpm--transporter--flatpickr {
  background-color: #cfecf9 !important;
  border: 0;
  height: 36px;
  box-shadow: 0 0 6px #0000000f;
  border-radius: 5px;
  font: normal normal bold 14px/15px;
  color: #343434;
}
/* MPM TRANSPORTER CUSTOM DESIGNS END */

/* ELEGANT BUTTON START */
.btn-elegant-download {
  box-shadow: 0px 2px 6px #0000001a;
  border-radius: 5px;
  /* font: normal normal 500 10px/11px Ubuntu; */
  color: #676767;
  width: 100%;
  height: 36px;
}

.btn-elegant {
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000014;
  border: 0.5px solid #eee;
  padding: 0.5rem 2rem;
  font: normal normal 500 10px/11px Ubuntu;
}

.btn-elegant-unselected {
  background: #eee 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000014;
  padding: 0.5rem 2rem;
  font: normal normal 500 10px/11px Ubuntu;
}
/* ELEGANT BUTTON END */

/* ELEGANT MULTISELECT START */
.elegant-multiselect {
  font-size: 12px;
  margin: 0;
}

.elegant-multiselect > .multiselect__tags {
  border: 0px solid white;
  min-height: 36px;
  padding-top: 10px;
}

.elegant-multiselect > .multiselect__select {
  height: 36px;
}
.elegant-multiselect {
  min-height: 36px;
  box-shadow: 0px 2px 6px #0000001a;
  border-radius: 5px;
  font: normal normal 500 10px/11px Ubuntu;
  color: #676767;
}
.elegant-multiselect .multiselect__placeholder {
  font-weight: bold;
  color: black;
}
.elegant-multiselect .multiselect__select::before {
  border-color: black transparent transparent;
}
/* ELEGANT MULTISELECT END */

table.tableBodyScroll tbody {
  /* display: block; */
  max-height: 300px;
  overflow: scroll;
}

table.tableBodyScroll thead,
table.tableBodyScroll tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
/* table.tableBodyScroll tbody {
		display: block;
		max-height: 500px;
		overflow-y: scroll;
	}

	table.tableBodyScroll thead, table.tableBodyScroll tbody tr {
		display: table;
		width: 100%;
		table-layout: fixed;
	} */

.mdi--truck-check {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M3 4h14v4h3l3 4v5h-2a3 3 0 0 1-3 3a3 3 0 0 1-3-3H9a3 3 0 0 1-3 3a3 3 0 0 1-3-3H1V6a2 2 0 0 1 2-2m14 5.5V12h4.47L19.5 9.5zm-11 6A1.5 1.5 0 0 0 4.5 17A1.5 1.5 0 0 0 6 18.5A1.5 1.5 0 0 0 7.5 17A1.5 1.5 0 0 0 6 15.5m12 0a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M8 14l6-6l-1.41-1.42L8 11.17L5.91 9.08L4.5 10.5z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.fluent--task-list-square-ltr-16-filled {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5zm6.5 6a.5.5 0 0 0 .5.5h2.25a.5.5 0 0 0 0-1H9a.5.5 0 0 0-.5.5M9 6a.5.5 0 0 0 0 1h2.25a.5.5 0 0 0 0-1zM7.354 9.146a.5.5 0 0 0-.708 0L5.5 10.293l-.394-.395a.5.5 0 0 0-.708.707l.748.749a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0 0-.708m0-3.292a.5.5 0 1 0-.708-.708L5.5 6.293l-.394-.395a.5.5 0 0 0-.708.708l.748.748a.5.5 0 0 0 .708 0z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.iconamoon--delivery-fast-fill {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M1 3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v5h4a5 5 0 0 1 5 5v4a3 3 0 0 1-2.129 2.872a3 3 0 0 1-5.7.128H8.83a3 3 0 0 1-5.7-.128A3 3 0 0 1 1 17v-4h6a1 1 0 1 0 0-2H1V9h4a1 1 0 0 0 0-2H1zm13 15h1.171a3 3 0 0 1 5.536-.293A1 1 0 0 0 21 17v-4a3 3 0 0 0-3-3h-4zm-7 1a1 1 0 1 0-2 0a1 1 0 0 0 2 0m10.293-.707A1 1 0 0 0 17 19a1 1 0 1 0 .293-.707' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.monitor {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml;base64,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");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.mdi--file-report {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M13 9h5.5L13 3.5zM6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2m1 18h2v-6H7zm4 0h2v-8h-2zm4 0h2v-4h-2z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.truck-location {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45MzkzIDE0LjA2MDdDMTYuMjIwNiAxNC4zNDIgMTYuNjAyMiAxNC41IDE3IDE0LjVDMTcuMzk3OCAxNC41IDE3Ljc3OTQgMTQuMzQyIDE4LjA2MDcgMTQuMDYwN0MxOC4zNDIgMTMuNzc5NCAxOC41IDEzLjM5NzggMTguNSAxM0MxOC41IDEyLjYwMjIgMTguMzQyIDEyLjIyMDYgMTguMDYwNyAxMS45MzkzQzE3Ljc3OTQgMTEuNjU4IDE3LjM5NzggMTEuNSAxNyAxMS41QzE2LjYwMjIgMTEuNSAxNi4yMjA2IDExLjY1OCAxNS45MzkzIDExLjkzOTNDMTUuNjU4IDEyLjIyMDYgMTUuNSAxMi42MDIyIDE1LjUgMTNDMTUuNSAxMy4zOTc4IDE1LjY1OCAxMy43Nzk0IDE1LjkzOTMgMTQuMDYwN1pNMjAuNDYgOEwxOC41IDUuNUgxNlY4SDIwLjQ2Wk0zLjkzOTM0IDE0LjA2MDdDNC4yMjA2NCAxNC4zNDIgNC42MDIxOCAxNC41IDUgMTQuNUM1LjM5NzgyIDE0LjUgNS43NzkzNiAxNC4zNDIgNi4wNjA2NiAxNC4wNjA3QzYuMzQxOTYgMTMuNzc5NCA2LjUgMTMuMzk3OCA2LjUgMTNDNi41IDEyLjYwMjIgNi4zNDE5NiAxMi4yMjA2IDYuMDYwNjYgMTEuOTM5M0M1Ljc3OTM2IDExLjY1OCA1LjM5NzgyIDExLjUgNSAxMS41QzQuNjAyMTggMTEuNSA0LjIyMDY0IDExLjY1OCAzLjkzOTM0IDExLjkzOTNDMy42NTgwNCAxMi4yMjA2IDMuNSAxMi42MDIyIDMuNSAxM0MzLjUgMTMuMzk3OCAzLjY1ODA0IDEzLjc3OTQgMy45MzkzNCAxNC4wNjA3Wk0xNiA0SDE5TDIyIDhWMTNIMjBDMjAgMTMuNzk1NiAxOS42ODM5IDE0LjU1ODcgMTkuMTIxMyAxNS4xMjEzQzE4LjU1ODcgMTUuNjgzOSAxNy43OTU2IDE2IDE3IDE2QzE2LjIwNDQgMTYgMTUuNDQxMyAxNS42ODM5IDE0Ljg3ODcgMTUuMTIxM0MxNC4zMTYxIDE0LjU1ODcgMTQgMTMuNzk1NiAxNCAxM0g4QzggMTMuNzk1NiA3LjY4MzkzIDE0LjU1ODcgNy4xMjEzMiAxNS4xMjEzQzYuNTU4NzEgMTUuNjgzOSA1Ljc5NTY1IDE2IDUgMTZDNC4yMDQzNSAxNiAzLjQ0MTI5IDE1LjY4MzkgMi44Nzg2OCAxNS4xMjEzQzIuMzE2MDcgMTQuNTU4NyAyIDEzLjc5NTYgMiAxM0gwVjcuNVYyQzAgMC44OSAwLjg5IDAgMiAwSDlIMTZWNFpNNiA1LjQ1QzYgNC4xMiA3LjE0Mjg2IDMgOC41IDNDOS44NTcxNCAzIDExIDQuMTIgMTEgNS40NUMxMSA3LjI3IDguNSAxMCA4LjUgMTBDOC41IDEwIDYgNy4yNyA2IDUuNDVaTTguNSA2LjM2QzggNi4zNiA3LjY0Mjg2IDUuOTQgNy42NDI4NiA1LjUyQzcuNjQyODYgNS4wMyA4LjA3MTQzIDQuNjggOC41IDQuNjhDOC45Mjg1NyA0LjY4IDkuMzU3MTQgNS4xIDkuMzU3MTQgNS41MkM5LjQyODU3IDUuOTQgOSA2LjM2IDguNSA2LjM2WiIgZmlsbD0iI0JCQkJCQiIvPgo8L3N2Zz4K");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.mdi--truck-minus {
  display: inline-block;
  height: 18px;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m7-7.5H5V9h8zm5 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.sidebar .nav > li:nth-last-child(2) > a {
  position: relative;
  padding-top: 16px;
}

.sidebar .nav > li:nth-last-child(2) > a:before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: #ccc;
  position: absolute;
  top: 0;
}
</style>
<!-- 
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 85px;
  }

  .stats-inner-box p, .stats-inner-box h2{
    color: white;
  }
  .stats-inner-box p{
    margin:5% 0 0 12.5%;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    font-size: 2em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }

  .outer-box{
    padding:20px;
  }
  .inner-box{
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
    height: 85px;
  }
</style> -->
